import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    inrFormatter,
    responsivefy,
    tooltip_class,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 900,
        height: 400,
        margin: { top: 20, right: 40, bottom: 60, left: 60 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    const USE_STANDARD_AXIS_FONT_SIZES = true
    var size = USE_STANDARD_AXIS_FONT_SIZES ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (USE_STANDARD_AXIS_FONT_SIZES ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName,filterParam)

    // axios.post(url, filterParam).then(response => {
        let data = resData

        for (var i = 0; i < data.length; i++) {
            data[i].metric1 = +data[i].metric1;
            if (i > 0) {
                data[i]['CumulativeAmount'] = data[i].metric1 + data[i - 1].CumulativeAmount;
            } else {
                data[i]['CumulativeAmount'] = data[i].metric1;
            }
        }

        //Axes and scales
        var x1Scale = d3.scaleBand().rangeRound([0, chartWidth]).paddingInner(.1);
        x1Scale.domain(data.map(function (d) {
            return d.dim1_name;
        }));

        var y1Scale = d3.scaleLinear()
            .domain([0, d3.max(data, (d) => {
                return d.metric1;
            })])
            .range([chartHeight, 0]);

        var y2Scale = d3.scaleLinear()
            .domain([0, d3.max(data, (d) => {
                return d.CumulativeAmount
            })])
            .range([chartHeight, 0]);

        var x1AxisLabel = d3.axisBottom().scale(x1Scale)

        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat((d) => {
            return inrFormatter(d)
        });

        var y2AxisLabel = d3.axisRight().scale(y2Scale).tickFormat((d) => {
            return inrFormatter(d)
        });

        //Draw svg
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId).append("svg")
            .attr("width", chartWidth + chartMargin.left + chartMargin.right)
            .attr("height", chartHeight + 4 * chartMargin.top + chartMargin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chartMargin.left + "," + chartMargin.top + ")");

        d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip' + divId.id)
            .html((d) => {
                return (chart.x1MetricTooltip + colonAnnotation + d.dim1_name + "</br>" + chart.y2MetricTooltip + colonAnnotation + inrFormatter(d.metric1) + "</span>")
            })

        svg.call(y1tip)

        var y2tip = tooltip_class()

        y2tip.attr('class', 'd3-tip' + divId.id)
            .html((d) => {
                return (chart.y1MetricTooltip + colonAnnotation + inrFormatter(d.CumulativeAmount))
            })

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chartMargin.left - 3)
            .attr('x', 0 - (chartHeight / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('x', (chartWidth / 3))
            .attr('y', chartHeight + chartMargin.bottom + 14 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', chartWidth + chartMargin.right - chart.vizSpecific1)
            .attr('x', 0 - (chartHeight / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y2AxisDisplayName)
            .style('font-size', fontSize)

        svg.call(y2tip)

        //Draw histogram
        var bar = svg.selectAll(".bar")
            .data(data)
            .enter()
            .append("g")
            .attr("fill", "steelblue")
            .on("mouseover", y1tip.show)
            .on("mouseout", y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        bar.append("rect")
            .attr("x", function (d) {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 4;
            })
            .attr("width", x1Scale.bandwidth() / 2)
            .attr("y", function (d) {
                return y1Scale(d.metric1);
            })
            .attr("height", function (d) {
                return chartHeight - y1Scale(d.metric1);
            });

        //Draw CDF line
        var guide = d3.line()
            .x(function (d) {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2;
            })
            .y(function (d) {
                return y2Scale(d.CumulativeAmount)
            });

        svg.append('path')
            .datum(data)
            .attr('d', guide)
            .attr('fill', "none")
            .attr('stroke', 'purple')
            .attr("stroke-width", "1.5px")

        svg.selectAll("dot")
            .data(data)
            .enter().append("circle")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2;
            })
            .attr("cy", function (d) {
                return y2Scale(d.CumulativeAmount);
            })
            .style("fill", "purple")
            .on("mouseover", y2tip.show)
            .on("mouseout", y2tip.hide);
        //    .attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID

        //Draw axes
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chartHeight + ")")
            .call(x1AxisLabel)
            .attr('class', 'axisL10')
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .attr('dy', '-0.55em')
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1)

        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .text("metric1");

        svg.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + [chartWidth, 0] + ")")
            .call(y2AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 4)
            .attr("dy", "-.71em")
            .style("text-anchor", "end")
            .text("Cumulative %");
    // })
}
